module.exports = __webpack_public_path__ + "static/media/i_like_B.e633c6d8.png";